module.exports = __webpack_public_path__ + "img/yt-wxbtrfly_usdc.7745dd0b.png";